
import loader from './loader'
import publico from './portal/publico'

const modules = {
  ...publico,
  loader
}

export default modules
